// product grid/list
function applyProductView(mode) {
  const productGrid = document.getElementById('product-grid');
  if (!productGrid) return;
  const isList = mode === 'list';
  productGrid.classList.toggle('product-list', isList);
  productGrid.classList.toggle('product-grid', !isList);
  document.querySelectorAll('.wblistgridbtn').forEach(btn => {
    btn.classList.toggle('active', isList ? btn.classList.contains('listv') : btn.classList.contains('gridv'));
  });
}

function listgridJavascript() {
  const savedView = sessionStorage.getItem('productViewMode');
  if (savedView) applyProductView(savedView);

  if (!document.getElementById('product-grid')) return;

  document.querySelectorAll('.wblistgridbtn').forEach(link => {
    if (link.dataset.viewBound) return;
    link.dataset.viewBound = 'true';
    link.addEventListener('click', function() {
      const mode = this.classList.contains('listv') ? 'list' : 'grid';
      sessionStorage.setItem('productViewMode', mode);
      applyProductView(mode);
    });
  });

  const container = document.getElementById('ProductGridContainer');
  if (container && !container.dataset.viewObserver) {
    container.dataset.viewObserver = 'true';
    new MutationObserver(() => {
      const view = sessionStorage.getItem('productViewMode');
      if (view) applyProductView(view);
    }).observe(container, { childList: true, subtree: true });
  }
}
document.addEventListener("shopify:section:load", listgridJavascript);
listgridJavascript();